import {
  WttpQuestionnaireResponse,
  WttpQuestionnaireResponseStatus,
} from 'src/graphql/generated/graphql';
import { Chip } from '@otp/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

const EXPIRED_STATUS = 'expired';

const statusColorMap = {
  [WttpQuestionnaireResponseStatus.Started]: 'warning',
  [WttpQuestionnaireResponseStatus.Pending]: 'primary',
  [WttpQuestionnaireResponseStatus.Completed]: 'success',
  [EXPIRED_STATUS]: 'error',
};

type StatusProps = {
  status?: WttpQuestionnaireResponseStatus;
  wttpQuestionnaireResponse: Pick<
    WttpQuestionnaireResponse,
    'completeRatio' | 'isActive' | 'completedAt' | 'status'
  >;
};

export const Status = ({ status, wttpQuestionnaireResponse }: StatusProps) => {
  const { t } = useTranslation();

  if (!status || !wttpQuestionnaireResponse) {
    return null;
  }

  const calculatedStatus = (
    (!wttpQuestionnaireResponse.isActive ||
      wttpQuestionnaireResponse.status ===
        WttpQuestionnaireResponseStatus.Expired) &&
    !wttpQuestionnaireResponse.completedAt
      ? EXPIRED_STATUS
      : status
  ) as keyof typeof statusColorMap;

  const percentageOfDone = Math.round(
    (wttpQuestionnaireResponse.completeRatio || 0) * 100,
  );

  return (
    <Chip
      label={t(
        `wttp.questionnaire-response.list.status.${calculatedStatus.toLowerCase()}`,
        {
          percentage: percentageOfDone,
        },
      )}
      size="small"
      color={statusColorMap[calculatedStatus] as any}
      className="!ml-0"
    />
  );
};
